
import WDCard from './wd-card';
import WDListSort from '../lists/wd-list-sort';
import WDNavbar from '../navbar/wd-navbar';

export default class WDCardList extends WDCard {

	#config;
	#proxy;
	#fetch;
	#list;
	#filters;
	      	
	constructor(cfg)
	{
		super(cfg).classList.add('wd-card-list');

		this.#config = Object.assign({},cfg);
	};

  /**
    loads the list with the config and executes a fetch
    */
  load(cfg)
  {
    return new Promise( (resolve,reject) => {

      //init the list
      this.list(cfg); 

      if (cfg?.fetch)
      {
        this.runFetch().then( () => {
          resolve( this.#list.proxy() );
        });
      }
      else
      {
        resolve( this.#list.proxy() );
      }
    });
  };	

	/**
		* sets up the underlying list for the pane
		*/
	list(cfg) { 
	
		if (typeof(cfg) == 'undefined')
		{
			return this.#list; 
		}
		else
		{
			this.#list = new WDListSort(cfg);
			if (cfg?.scrollable) this.#list.classList.add('scrollable');

			this.body().append(this.#list);

			//I can't decide on naming yet
			if (cfg.filters) 
			{
	    	let filterCfg = null;

	    	//I can't decide on naming yet
	    	if (cfg?.filters) filterCfg = {filters:cfg.filters};
	    	else if (cfg?.filterConfig) filterCfg = cfg.filterConfig;
	    	else if (cfg?.filterbar) filterCfg = cfg.filterbar;			//sticking with "filterbar" for the future when I need to pass an advancedd config
	    																													//but will leave filterConfig for compatibility
	    	if (filterCfg)
	    	{
        	this.filters(filterCfg).on('filter:apply',() => this.runFetch() );
				}
			}
			
			return this.#list;
		}
	};

	config() { return this.#config; };
	proxy() { return this.#list.proxy(); };
	fetch() { return this.#list.fetch(); };
	results() { return this.#list.results(); };
	
  /**
  	* setup a filter bar for filtering our fetch requests
  	*/
  filters(cfg)
  {
    if (!this.#filters && typeof(cfg) != 'undefined')
    {
    	const nav = this.header().navbar();
    	
      //setup the navbar and use the search field as the brand
      this.#filters = nav.addFilters(cfg);
      this.#filters.on('filter:apply',() => this.runFetch() );
    }

    return this.#filters;
  };

  //legacy call
  refresh() { this.runFetch(); };

  runFetch()
  {
  	const formData = {};
  	
		if (this.#filters) formData.filters = this.#filters.serialize();

		//clean up our filter data to remove any nulls or empty values
		for (let key in formData)
		{
			const val = formData[key];

			//remove empty form data so it doesn't get passed to the api			
			if (val === null || String(val).length == 0) delete( this.fetch()[key] );

			//otherwise set the value to pass along
			else this.fetch()[key] = val;
		}

		//merge in sort data for the request - should this be done in 
		//WDListProxy since that's where the sorting is...
		if ( this.#list?.sortField() != null ) this.fetch().sort_field = this.#list.sortField();
		if ( this.#list?.sortDir() != null ) this.fetch().sort_dir = this.#list.sortDir();

		//run the search
		return this.#list.req();
  };

};

customElements.define('wd-card-list',WDCardList);
